/**
 * The shared notification identity for one open request. Every platform reuses
 * this string as its *native* notification key — Android notification id,
 * Desktop notification map key, web `tag`, Wear data path — so a single
 * `attention.cleared` event can revoke the same card on every device.
 *
 * Both the gateway (raising) and the clients (revoking) must derive the key the
 * same way, which is why it lives in shared rather than in either one.
 */
export function attentionKey(kind, requestId) {
    return `${kind}:${requestId}`;
}
//# sourceMappingURL=message.js.map